import type { ReactNode } from 'react'

import type {
  AnalyticsCardHeader,
  ReportLink,
} from '../../../analyticsModule/components/AnalyticsCard/AnalyticsCard.types'
import type { AnalyticsExternalSource } from '../../../analyticsModule/types'
import type { useAnalyticsReportBase } from '../../../hooks/useAnalyticsReportBase'
import { formatChartValue } from '../../AnalyticsReport/hooks/utils/formatChartValue'
import { createAnalyticsCardHeader } from './createAnalyticsCardHeader'

type AnalyticsCardBaseProps = {
  isDataLoading: boolean
  isDefinitionLoading: boolean
  reportLink: ReportLink | undefined
  legend: string
  externalSource: AnalyticsExternalSource | undefined
  emptyMessage: string
  header: AnalyticsCardHeader
  formatValue: (value: number) => ReactNode
}

export const createAnalyticsCardBaseProps = ({
  isReportDataLoading,
  isReportDefinitionLoading,
  reportLink,
  legend,
  externalSource,
  emptyMessage,
  reportDefinition,
  activeColumn,
}: ReturnType<typeof useAnalyticsReportBase>): AnalyticsCardBaseProps => ({
  isDataLoading: isReportDataLoading,
  isDefinitionLoading: isReportDefinitionLoading,
  reportLink,
  legend,
  externalSource,
  emptyMessage,
  header: createAnalyticsCardHeader(reportDefinition, activeColumn),
  formatValue: (value: number) => formatChartValue({ value, type: activeColumn?.type }),
})
